import React from 'react'
import financeIconSprite from 'assets/img/finance/sprite.svg'

const statusIconTypeMap = {
  'page.finance.event.status.waiting': 'status_waiting',
  'page.finance.event.status.approved': 'status_approved',
  'page.finance.event.status.rejected': 'status_rejected',
  'page.finance.event.status.canceled': 'status_canceled',
}

const StatusIcon = ({ status, ...props }) => {
  const statusIconId = statusIconTypeMap[status] || null;

  if (!statusIconId) {
    return null
  }

  return (
    <svg width={14} height={14} {...props}>
      <use href={`${financeIconSprite}#${statusIconId}`} />
    </svg>
  )
}

export default StatusIcon
